<template>
  <div>
    <Card back>
      <template v-slot:header>
        <h4 class="d-inline">مدیریت دپارتمان ها</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="container" :id="$route.name">
          <h3 v-if="!AddDepartmanShow">
            <i class="px-3"
              :class="[ShowDepartmentForm ? ['fas Pointer', 'fa-times', 'text-danger'] : ['fas Pointer', 'fa-plus', 'text-success']]"
              @click="
                ShowDepartmentForm = !ShowDepartmentForm
                Department.DepartmentName = ''
                ShowEditDepartmentBtn = false
                Department.CustomerSee = false
              "></i>
          </h3>
          <h3 v-else><i class="px-3 fas fa-times text-danger" @click="AddDepartmanShow = false"></i></h3>
          <div class="row mb-3" v-if="ShowDepartmentForm">
            <div class="col-md-4 col-12">
              <small id="LblDepartmentName">نام دپارتمان</small>
              <input type="text" class="form-control" v-model="Department.DepartmentName"
                placeholder="نــام دپارتمان" />
            </div>
            <div class="col-md-4 col-12">
              <small id="LblDepartmentIcon">آیکون</small>
              <input type="text" class="form-control" dir="ltr" v-model="Department.DepartmentIcon"
                placeholder="Icon" />
            </div>

            <div class="mt-4 col-md-4 col-12">
              <span class="form-control p-1">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input InputText" id="Archive" v-if="Department.CustomerSee" checked
                    v-model="Department.CustomerSee" />
                    <input type="checkbox" class="custom-control-input InputText" id="Archive" v-else 
                    v-model="Department.CustomerSee" />
                  <label class="custom-control-label" for="Archive">مشتری دپارتمان را ببیند</label>
                </div>
              </span>
            </div>

            <div class="col-md-4 col-12 mt-4">
              <button class="btn btn-success" @click="SubmitDepartment" v-if="!ShowEditDepartmentBtn">ثـبـت
                دپارتمان</button>
              <button class="btn btn-info" @click="EditDepartment" v-if="ShowEditDepartmentBtn">ویرایش دپارتمان</button>
            </div>

          </div>

          <div class="row" v-if="AddDepartmanShow">
            <div class="col-md-3 col-12">
              <small id="LblUserId">اضافه به دپارتمان <u class="text-info">{{ DepartmentNameForAdd }}</u></small>
              <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResulUserId" :rownumintable="3"
                :action="'TblCrmCombo/GetUserDatails'" :method="'POST'" :idinput="'UserId'" :keyItem="'UserId'"
                :disabled="false"> </SearchableCombo>
            </div>
          </div>
          <div v-if="!ShowDepartmentForm" class="row">
            <div class="col-md-3 col-12 mb-4" v-for="item in DepartmanUsers" :key="item.departmentId">
              <div class="card h-100">
                <div class="card-header">
                  <i :class="item.departmentIcon == null ? 'fad fa-users-class' : item.departmentIcon"></i> &nbsp;
                  &nbsp;{{ item.departmentName }}
                  <b-dropdown size="md" variant="link" class="d-inline float-left btn-more text-center"
                    toggle-class="text-decoration-none " no-caret>
                    <template #button-content>
                      <h4><i class="fad fa-ellipsis-v"></i></h4>
                    </template>
                    <b-dropdown-item @click="AddUserToDepartment(item)" class="text-center">اضافه کردن کاربر
                    </b-dropdown-item>
                    <b-dropdown-item @click="ShowEditDepartmentForm(item)" class="text-center"> ویرایش</b-dropdown-item>
                    <b-dropdown-item @click="RemoveDepartment(item)" class="text-center">حذف </b-dropdown-item>
                  </b-dropdown>
                </div>
                <div class="card-body">
                  <span class="badge border m-1 p-2" v-for="users in item.users" :key="users.userId">
                    {{ users.userNameFa }} &nbsp;&nbsp;
                    <i @click="RemoveUser(item, users)" class="fas fa-times hover-danger"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'

export default {
  components: { Card, BnpGrid, SearchableCombo },
  data() {
    return {
      DepartmanUsers: [],
      ShowDepartmentForm: false,
      ShowEditDepartmentBtn: false,
      Department: {
        DepartmentName: null,
        Id: null,
        DepartmentIcon: null,
        CustomerSee: false,
        TblUserGrpIdInsert: this.tblUserGrpIdInsert
      },
      hover: false,
      UserIdForAddToDepartment: null,
      DepartmentIdForAddToUser: null,
      AddDepartmanShow: false,
      DepartmentNameForAdd: '',
      tblUserGrpIdInsert: this.$session.get('UserInfo').tblUserGrpId,
    }
  },

  created() {
    var DataaxiosDepUser = {
      Action: 'Department',
      Method: 'Get',
      ArryfildValue: null,
    }
    this.$PostData(DataaxiosDepUser)
      .then((response) => {
        this.DepartmanUsers = response
      })
      .catch((error) => {
        console.error('CATCH', error)
      })
      .finally(() => { })
  },

  methods: {
    RemoveUser(item, user) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success mx-1',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })
      swalWithBootstrapButtons
        .fire({
          title: 'اطمینان دارید؟',
          text: 'از حذف ' + user.userNameFa + ' از دپارتمان ' + item.departmentName + '؟',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'بله، حذف شود',
          cancelButtonText: 'لغو',
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            var DataaxiosDepUser = {
              Action: 'Department/DeleteUserFromDepartment',
              Method: 'Delete',
              ArryfildValue: {
                tblDepartmentId: item.departmentId,
                tblUserId: user.userId,
              },
            }
            this.$PostData(DataaxiosDepUser)
              .then((response) => {

                var recordDepartment = this.DepartmanUsers.find(x=> x.departmentId == item.departmentId)
                var indexDepartment = this.DepartmanUsers.indexOf(recordDepartment)

                var recordUsers = this.DepartmanUsers[indexDepartment].users.find(x=> x.userId == user.userId)
                var indexUser = this.DepartmanUsers[indexDepartment].users.indexOf(recordUsers)

                this.DepartmanUsers[indexDepartment].users.splice(indexUser, 1)


                                // const indexDepartment = this.DepartmanUsers.indexOf(item)
                // const index = this.DepartmanUsers[indexDepartment].users.indexOf(user)
                // this.DepartmanUsers[indexDepartment].users.splice(index, 1)

                // swalWithBootstrapButtons.fire('', 'یوزر با موفقیت از دپارتمان حذف شد', 'success')

                this.$toasted.success("حذف با موفقیت صورت گرفت", {
                  action: {
                    text: "بستن",
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    },
                  },
                });

              })
              .catch((error) => {
                console.error('CATCH', error)
                swalWithBootstrapButtons.fire('', 'عملیات با خطا مواجه شد', 'error')
              })
          }
        })
    },

    GetResulUserId(data) {
      if (data.element != null) {
        var DataaxiosDepUser = {
          Action: 'Department/AddUserToDepartment',
          Method: 'Post',
          ArryfildValue: {
            tblDepartmentId: this.DepartmentIdForAddToUser,
            tblUserId: data.element.id,
            tblUserGrpIdInsert: this.tblUserGrpIdInsert
          },
        }

        this.$PostData(DataaxiosDepUser)
          .then((response) => {
            if (response.isSuccess == true) {
              var record = this.DepartmanUsers.find((element) => element.departmentId == DataaxiosDepUser.ArryfildValue.tblDepartmentId)
              record.users.push({
                userId: data.id,
                userNameFa: data.name,
              })
              this.$mySweetDefaultTost('عملیات موفق', response.message, 'success', 2000)
            } else {
              this.$mySweetDefaultTost('عملیات ناموفق', response.message, 'error', 2000)
            }
          })
          .catch((error) => {
            console.error('CATHCH', error)
            this.$mySweetDefaultTost('عملیات ناموفق', 'عملیات با خطا مواجه شد', 'error', 2000)
          })
      }
    },

    ShowEditDepartmentForm(item) {
      this.Department.Id = item.departmentId
      this.Department.DepartmentName = item.departmentName
      this.Department.DepartmentIcon = item.departmentIcon
      this.Department.CustomerSee = item.customerSee
      this.AddDepartmanShow = false
      this.ShowEditDepartmentBtn = true
      this.ShowDepartmentForm = true
      this.$store.state.OldDataForLog = JSON.stringify(this.Department)
    },

    EditDepartment() {
      if (this.validation()) {
        var DataaxiosDepUser = {
          Action: 'Department',
          Method: 'Put',
          ArryfildValue: this.Department,
        }
        this.$PostData(DataaxiosDepUser)
          .then((response) => {
            this.ShowDepartmentForm = false
            this.ShowEditDepartmentBtn = false
            var record = this.DepartmanUsers.find((element) => element.departmentId == this.Department.Id)
            record.departmentName = this.Department.DepartmentName
            record.customerSee = this.Department.CustomerSee
            record.departmentIcon = this.Department.DepartmentIcon
            this.$SetLog(this.Department, 0)
            this.Department.DepartmentName = ''
            this.Department.CustomerSee = false
            this.Department.DepartmentIcon = null
            this.$mySweetDefaultTost('عملیات موفق', 'دپارتمان با موفقیت ویرایش شد', 'success', 1000)
          })
          .catch((error) => {
            this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
            console.error('CATCH', error)
          })
      }
    },

    RemoveDepartment(item) {
      this.$store.state.OldDataForLog = JSON.stringify(item)
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success mx-1',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })
      swalWithBootstrapButtons
        .fire({
          title: 'اطمینان دارید؟',
          text: 'از حذف دپارتمان ' + item.departmentName + '؟',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'بله، حذف شود',
          cancelButtonText: 'لغو',
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            var DataaxiosDepUser = {
              Action: 'Department',
              Method: 'Delete',
              ArryfildValue: item.departmentId,
            }
            this.$PostData(DataaxiosDepUser)
              .then((response) => {
                
                var record = this.DepartmanUsers.find(x=> x.departmentId == item.departmentId)
                var index = this.DepartmanUsers.indexOf(record)
                this.DepartmanUsers.splice(index, 1);
                this.$SetLog(this.Department, 1)
                
                this.$toasted.success("حذف با موفقیت صورت گرفت", {
                  action: {
                    text: "بستن",
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    },
                  },
                });
              })
              .catch((error) => {
                this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
                console.error('CATCH', error)
              })
          }
        })
    },

    AddUserToDepartment(item) {
      this.ShowDepartmentForm = false
      this.AddDepartmanShow = true
      this.DepartmentNameForAdd = item.departmentName
      this.DepartmentIdForAddToUser = item.departmentId
    },

    SubmitDepartment() {
      if (this.validation()) {
        this.Department.Id = 1
        var DataaxiosDepUser = {
          Action: 'Department',
          Method: 'Post',
          ArryfildValue: this.Department,
        }
        this.Department.tblUserGrpIdInsert = this.tblUserGrpIdInsert
        this.$PostData(DataaxiosDepUser)
          .then((response) => {
            this.Department.DepartmentName = ''
            this.DepartmanUsers.push(response)
            this.$mySweetDefaultTost('عملیات موفق', 'دپارتمان جدید با موفقیت ثبت شد', 'success', 1000)
          })
          .catch((error) => {
            this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
            console.error('CATCH', error)
          })
      }
    },

    validation() {
      var departmentName = this.Department.DepartmentName
      if (departmentName == null) {
        this.$mySweetDefaultTost('عملیات ناموفق', 'وارد کردن نام دپارتمان الزامی است', 'info', 3000)
        return false
      }
      departmentName = departmentName.replace(/\s/g, '')
      if (departmentName == '') {
        this.$mySweetDefaultTost('عملیات ناموفق', 'وارد کردن نام دپارتمان الزامی است', 'info', 3000)
        return false
      } else {
        return true
      }
    },
  },
}
</script>

<style scoped>
.card {
  background: var(--sidebar-bg-color);
  border: solid 1px var(--logo-color);
}

.card-header {
  color: var(--logo-color);
  border: solid 1px var(--logo-color);
}

.hover-danger:hover {
  color: #a11414 !important;
  cursor: pointer;
}

u.text-info {
  font-size: 15px;
}

.badge {
  font-weight: normal !important;
  background: var(--sidebar-bg-color);
}

.badge:hover {
  cursor: pointer;
  font-size: medium;
  font-weight: bold;
  transform: 1s !important;
}
</style>
